import normalizeApiError from '../utils/apiError';

import { mtnApi } from './api';

const normalizePrice = (price = 0) => {
  const numericPrice = Number(price);

  if (!Number.isFinite(numericPrice) || numericPrice <= 0) {
    return 0;
  }

  return numericPrice;
};

const normalizeProductItem = (item) => {
  if (!item || typeof item !== 'object') {
    return null;
  }

  const model = item.models || {};
  const images = Array.isArray(model.images) ? model.images : [];
  const firstImage = images.find((imageItem) => imageItem && imageItem.image);
  const imagePath = firstImage?.image || item.image || item.photo || '';

  return {
    id: item.id,
    name: model.name || '',
    brandName: item.brands.name || '',
    price: normalizePrice(item.price_actual ?? 0),
    image: imagePath,
  };
};

export const getProductsByPrice = async (price) => {
  const safePrice = normalizePrice(price);

  if (!safePrice) {
    return { success: true, data: [] };
  }

  try {
    const { data } = await mtnApi.post('/search/byPrice', { price: safePrice });
    const products = (data.results || []).map((item) => normalizeProductItem(item)).filter(Boolean);

    return { success: true, data: products };
  } catch (error) {
    return normalizeApiError(error, {
      context: 'getting products',
      fallbackMessage: 'No pudimos cargar los productos. Intentá nuevamente.'
    });
  }
};